import React from 'react';
import { ThemeProvider } from 'emotion-theming';
const ThemeWrapper = ({ theme, children }) => (React.createElement(ThemeProvider, { theme: theme }, children));
export default ThemeWrapper;
